export default __webpack_public_path__ + "media/src/features/open-house-registration-my-activity/assets/rightArrow-d8d7a08477e7ea2bdfa4b9067060d7ad.svg";